var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCoverCropIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 74,
    viewBox: "0 0 82 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.7821 36.8543C77.7828 31.3546 76.5547 25.9245 74.188 20.9623C71.8213 16 68.3758 11.6314 64.1044 8.17689C59.833 4.72234 54.844 2.26945 49.5031 0.998108C44.1623 -0.273233 38.6052 -0.330781 33.2393 0.829682C27.8733 1.99014 22.8347 4.33919 18.493 7.70454C14.1512 11.0699 10.6164 15.3662 8.14775 20.2784C5.67913 25.1906 4.33929 30.594 4.22651 36.0925C4.11374 41.591 5.23087 47.0451 7.496 52.0547H74.5048C76.6684 47.2806 77.7859 42.0974 77.7821 36.8543Z",
    fill: "#F7F8FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49219 52.0547C10.4096 58.507 15.1215 63.9801 21.0636 67.8189C27.0057 71.6576 33.9262 73.6991 40.9966 73.6991C48.067 73.6991 54.9875 71.6576 60.9297 67.8189C66.8718 63.9801 71.5836 58.507 74.501 52.0547H7.49219Z",
    fill: "#CCF7AD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1081 51.7109H8.36719C10.7168 58.2051 15.2016 63.8499 21.189 67.8488C27.1763 71.8478 34.3639 73.999 41.7377 73.999C49.1114 73.999 56.299 71.8478 62.2863 67.8488C68.2737 63.8499 72.7586 58.2051 75.1081 51.7109Z",
    fill: "#F7CA50"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.14062 52.0547H76.8649",
    stroke: "#0E2032",
    strokeWidth: 0.798592,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1 52.0547H3.29885",
    stroke: "#0E2032",
    strokeWidth: 0.798592,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7031 52.0547H81.002",
    stroke: "#0E2032",
    strokeWidth: 0.798592,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9453 52.0548V19.9062",
    stroke: "#0E2032",
    strokeWidth: 0.798592,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1145 44.2703L50.9453 49.2827V44.2942C50.9453 44.2942 53.7113 39.8594 55.9246 39.8594C58.0598 39.8594 59.1485 44.0529 59.5752 46.274C59.5921 46.3546 59.5819 46.4385 59.5463 46.5128C59.5107 46.587 59.4517 46.6474 59.3783 46.6845C59.305 46.7217 59.2214 46.7336 59.1406 46.7183C59.0598 46.703 58.9863 46.6615 58.9315 46.6001C58.035 45.6374 56.5564 44.3311 55.1145 44.2703Z",
    fill: "#FFE137",
    stroke: "#0E2032",
    strokeWidth: 0.798592,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4809 42.6309L55.1172 44.2697",
    stroke: "#0E2032",
    strokeWidth: 0.798592,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7779 44.2703L50.9471 49.2827V44.2942C50.9471 44.2942 48.1802 39.8594 45.9641 39.8594C43.829 39.8594 42.7402 44.0529 42.3126 46.274C42.2958 46.3546 42.3059 46.4385 42.3415 46.5128C42.3771 46.587 42.4362 46.6474 42.5095 46.6845C42.5829 46.7217 42.6665 46.7336 42.7472 46.7183C42.828 46.703 42.9015 46.6615 42.9563 46.6001C43.8575 45.6374 45.3361 44.3311 46.7779 44.2703Z",
    fill: "#FFE137",
    stroke: "#0E2032",
    strokeWidth: 0.798592,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4141 42.6309L46.7777 44.2697",
    stroke: "#0E2032",
    strokeWidth: 0.798592,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1145 35.9558L50.9453 40.9674V35.9788C50.9453 35.9788 53.7113 31.5449 55.9246 31.5449C58.0598 31.5449 59.1485 35.7384 59.5752 37.9595C59.5921 38.0401 59.5819 38.1241 59.5463 38.1983C59.5107 38.2725 59.4517 38.3329 59.3783 38.3701C59.305 38.4073 59.2214 38.4191 59.1406 38.4039C59.0598 38.3886 58.9863 38.347 58.9315 38.2856C58.035 37.3229 56.5564 36.0166 55.1145 35.9558Z",
    fill: "#FFE137",
    stroke: "#0E2032",
    strokeWidth: 0.798592,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4809 34.3164L55.1172 35.9562",
    stroke: "#0E2032",
    strokeWidth: 0.798592,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7779 35.9558L50.9471 40.9674V35.9788C50.9471 35.9788 48.1802 31.5449 45.9641 31.5449C43.829 31.5449 42.7402 35.7384 42.3126 37.9595C42.2958 38.0401 42.3059 38.1241 42.3415 38.1983C42.3771 38.2725 42.4362 38.3329 42.5095 38.3701C42.5829 38.4073 42.6665 38.4191 42.7472 38.4039C42.828 38.3886 42.9015 38.347 42.9563 38.2856C43.8575 37.3229 45.3361 36.0166 46.7779 35.9558Z",
    fill: "#FFE137",
    stroke: "#0E2032",
    strokeWidth: 0.798592,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4141 34.3164L46.7777 35.9562",
    stroke: "#0E2032",
    strokeWidth: 0.798592,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6584 27.0731C55.6171 27.3713 56.5337 27.7915 57.3858 28.3232C57.4533 28.3633 57.5309 28.3828 57.6093 28.3796C57.6877 28.3763 57.7635 28.3503 57.8274 28.3048C57.8914 28.2593 57.9408 28.1961 57.9696 28.123C57.9984 28.0499 58.0055 27.97 57.9899 27.893C57.7039 26.4604 56.9582 23.7852 55.3711 23.7852C53.1577 23.7852 50.9453 28.22 50.9453 28.22V32.6539L54.6584 27.0731Z",
    fill: "#FFE137",
    stroke: "#0E2032",
    strokeWidth: 0.798592,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3767 26.002L54.6641 27.0724",
    stroke: "#0E2032",
    strokeWidth: 0.798592,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M47.238 27.0731C46.2794 27.3715 45.3628 27.7917 44.5107 28.3232C44.4432 28.3633 44.3655 28.3828 44.2871 28.3796C44.2087 28.3763 44.133 28.3503 44.069 28.3048C44.0051 28.2593 43.9557 28.1961 43.9268 28.123C43.898 28.0499 43.8909 27.97 43.9065 27.893C44.1925 26.4604 44.9392 23.7852 46.5254 23.7852C48.7387 23.7852 50.952 28.22 50.952 28.22V32.6539L47.238 27.0731Z",
    fill: "#FFE137",
    stroke: "#0E2032",
    strokeWidth: 0.798592,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5234 26.002L47.2361 27.0724",
    stroke: "#0E2032",
    strokeWidth: 0.798592,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6584 18.7586C55.7309 19.1056 56.7547 19.5885 57.7049 20.1957C57.7439 20.219 57.7887 20.2305 57.834 20.229C57.8794 20.2274 57.9233 20.2129 57.9607 20.1871C57.998 20.1613 58.0272 20.1254 58.0448 20.0835C58.0624 20.0415 58.0676 19.9955 58.0598 19.9507C57.8391 18.6803 57.109 15.4707 55.3711 15.4707C53.1577 15.4707 50.9453 19.9056 50.9453 19.9056V24.3395L54.6584 18.7586Z",
    fill: "#FFE137",
    stroke: "#0E2032",
    strokeWidth: 0.798592,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3767 17.6875L54.6641 18.758",
    stroke: "#0E2032",
    strokeWidth: 0.798592,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2403 18.7586C46.1681 19.1056 45.1446 19.5885 44.1947 20.1957C44.1558 20.2194 44.1109 20.2312 44.0653 20.2299C44.0198 20.2286 43.9757 20.2141 43.9382 20.1882C43.9007 20.1623 43.8714 20.1261 43.854 20.084C43.8365 20.0419 43.8316 19.9956 43.8398 19.9507C44.0605 18.6803 44.7897 15.4707 46.5276 15.4707C48.7409 15.4707 50.9543 19.9056 50.9543 19.9056V24.3395L47.2403 18.7586Z",
    fill: "#FFE137",
    stroke: "#0E2032",
    strokeWidth: 0.798592,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5234 17.6875L47.2361 18.758",
    stroke: "#0E2032",
    strokeWidth: 0.798592,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1953 52.0548V19.9062",
    stroke: "#0E2032",
    strokeWidth: 0.798592,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3645 44.2703L70.1953 49.2827V44.2942C70.1953 44.2942 72.9622 39.8594 75.1746 39.8594C77.3098 39.8594 78.3985 44.0529 78.8261 46.274C78.843 46.3546 78.8329 46.4385 78.7973 46.5128C78.7617 46.587 78.7026 46.6474 78.6292 46.6845C78.5559 46.7217 78.4723 46.7336 78.3915 46.7183C78.3107 46.703 78.2372 46.6615 78.1824 46.6001C77.285 45.6374 75.8064 44.3311 74.3645 44.2703Z",
    fill: "#FFE137",
    stroke: "#0E2032",
    strokeWidth: 0.798592,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7231 42.6309L74.3594 44.2697",
    stroke: "#0E2032",
    strokeWidth: 0.798592,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0233 44.2703L70.1925 49.2827V44.2942C70.1925 44.2942 67.4266 39.8594 65.2132 39.8594C63.0781 39.8594 61.9893 44.0529 61.5626 46.274C61.5458 46.3546 61.5559 46.4385 61.5915 46.5128C61.6271 46.587 61.6862 46.6474 61.7595 46.6845C61.8329 46.7217 61.9165 46.7336 61.9972 46.7183C62.078 46.703 62.1515 46.6615 62.2063 46.6001C63.1066 45.6374 64.5778 44.3311 66.0233 44.2703Z",
    fill: "#FFE137",
    stroke: "#0E2032",
    strokeWidth: 0.798592,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6641 42.6309L66.0277 44.2697",
    stroke: "#0E2032",
    strokeWidth: 0.798592,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3645 35.9558L70.1953 40.9674V35.9788C70.1953 35.9788 72.9622 31.5449 75.1746 31.5449C77.3098 31.5449 78.3985 35.7384 78.8261 37.9595C78.843 38.0401 78.8329 38.1241 78.7973 38.1983C78.7617 38.2725 78.7026 38.3329 78.6292 38.3701C78.5559 38.4073 78.4723 38.4191 78.3915 38.4039C78.3107 38.3886 78.2372 38.347 78.1824 38.2856C77.285 37.3229 75.8064 36.0166 74.3645 35.9558Z",
    fill: "#FFE137",
    stroke: "#0E2032",
    strokeWidth: 0.798592,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7231 34.3164L74.3594 35.9562",
    stroke: "#0E2032",
    strokeWidth: 0.798592,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0233 35.9558L70.1925 40.9674V35.9788C70.1925 35.9788 67.4266 31.5449 65.2132 31.5449C63.0781 31.5449 61.9893 35.7384 61.5626 37.9595C61.5458 38.0401 61.5559 38.1241 61.5915 38.1983C61.6271 38.2725 61.6862 38.3329 61.7595 38.3701C61.8329 38.4073 61.9165 38.4191 61.9972 38.4039C62.078 38.3886 62.1515 38.347 62.2063 38.2856C63.1066 37.3229 64.5778 36.0166 66.0233 35.9558Z",
    fill: "#FFE137",
    stroke: "#0E2032",
    strokeWidth: 0.798592,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6641 34.3164L66.0277 35.9562",
    stroke: "#0E2032",
    strokeWidth: 0.798592,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9093 27.0731C74.8679 27.3715 75.7845 27.7917 76.6367 28.3232C76.7042 28.3633 76.7818 28.3828 76.8602 28.3796C76.9386 28.3763 77.0144 28.3503 77.0783 28.3048C77.1423 28.2593 77.1917 28.1961 77.2205 28.123C77.2494 28.0499 77.2564 27.97 77.2408 27.893C76.9549 26.4604 76.2082 23.7852 74.622 23.7852C72.4086 23.7852 70.1953 28.22 70.1953 28.22V32.6539L73.9093 27.0731Z",
    fill: "#FFE137",
    stroke: "#0E2032",
    strokeWidth: 0.798592,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6189 26.002L73.9062 27.0724",
    stroke: "#0E2032",
    strokeWidth: 0.798592,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M66.482 27.0731C65.5227 27.3712 64.6055 27.7913 63.7528 28.3232C63.6853 28.3633 63.6077 28.3828 63.5293 28.3796C63.4509 28.3763 63.3752 28.3503 63.3112 28.3048C63.2473 28.2593 63.1979 28.1961 63.169 28.123C63.1402 28.0499 63.1331 27.97 63.1487 27.893C63.4347 26.4604 64.1804 23.7852 65.7676 23.7852C67.9809 23.7852 70.1933 28.22 70.1933 28.22V32.6539L66.482 27.0731Z",
    fill: "#FFE137",
    stroke: "#0E2032",
    strokeWidth: 0.798592,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7656 26.002L66.4783 27.0724",
    stroke: "#0E2032",
    strokeWidth: 0.798592,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9093 18.7586C74.9815 19.1056 76.005 19.5885 76.9549 20.1957C76.9938 20.2194 77.0387 20.2312 77.0843 20.2299C77.1298 20.2286 77.1739 20.2141 77.2114 20.1882C77.2489 20.1623 77.2782 20.1261 77.2956 20.084C77.3131 20.0419 77.318 19.9956 77.3098 19.9507C77.0891 18.6803 76.3599 15.4707 74.622 15.4707C72.4086 15.4707 70.1953 19.9056 70.1953 19.9056V24.3395L73.9093 18.7586Z",
    fill: "#FFE137",
    stroke: "#0E2032",
    strokeWidth: 0.798592,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6189 17.6875L73.9062 18.758",
    stroke: "#0E2032",
    strokeWidth: 0.798592,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M66.483 18.7586C65.4105 19.1056 64.3867 19.5885 63.4366 20.1957C63.3976 20.219 63.3527 20.2305 63.3074 20.229C63.2621 20.2274 63.2181 20.2129 63.1807 20.1871C63.1434 20.1613 63.1142 20.1254 63.0966 20.0835C63.0791 20.0415 63.0739 19.9955 63.0816 19.9507C63.3023 18.6803 64.0324 15.4707 65.7704 15.4707C67.9837 15.4707 70.1961 19.9056 70.1961 19.9056V24.3395L66.483 18.7586Z",
    fill: "#FFE137",
    stroke: "#0E2032",
    strokeWidth: 0.798592,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7656 17.6875L66.4783 18.758",
    stroke: "#0E2032",
    strokeWidth: 0.798592,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5625 52.0508V19.9023",
    stroke: "#0E2032",
    strokeWidth: 0.798592,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7317 44.2683L32.5625 49.2808V44.2923C32.5625 44.2923 35.3294 39.8574 37.5418 39.8574C39.677 39.8574 40.7657 44.0509 41.1933 46.272C41.2102 46.3526 41.2001 46.4366 41.1645 46.5108C41.1289 46.585 41.0698 46.6454 40.9964 46.6826C40.9231 46.7198 40.8395 46.7316 40.7587 46.7164C40.6779 46.7011 40.6044 46.6595 40.5496 46.5981C39.6522 45.6354 38.1735 44.3291 36.7317 44.2683Z",
    fill: "#FFE137",
    stroke: "#0E2032",
    strokeWidth: 0.798592,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0902 42.6289L36.7266 44.2678",
    stroke: "#0E2032",
    strokeWidth: 0.798592,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3905 44.2683L32.5597 49.2808V44.2923C32.5597 44.2923 29.7938 39.8574 27.5804 39.8574C25.4452 39.8574 24.3565 44.0509 23.9298 46.272C23.913 46.3526 23.9231 46.4366 23.9587 46.5108C23.9943 46.585 24.0534 46.6454 24.1267 46.6826C24.2001 46.7198 24.2836 46.7316 24.3644 46.7164C24.4452 46.7011 24.5187 46.6595 24.5735 46.5981C25.4737 45.6354 26.945 44.3291 28.3905 44.2683Z",
    fill: "#FFE137",
    stroke: "#0E2032",
    strokeWidth: 0.798592,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0312 42.6289L28.3949 44.2678",
    stroke: "#0E2032",
    strokeWidth: 0.798592,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7317 35.9539L32.5625 40.9654V35.9769C32.5625 35.9769 35.3294 31.543 37.5418 31.543C39.677 31.543 40.7657 35.7365 41.1933 37.9576C41.2102 38.0382 41.2001 38.1221 41.1645 38.1963C41.1289 38.2706 41.0698 38.331 40.9964 38.3681C40.9231 38.4053 40.8395 38.4172 40.7587 38.4019C40.6779 38.3866 40.6044 38.3451 40.5496 38.2837C39.6522 37.321 38.1735 36.0147 36.7317 35.9539Z",
    fill: "#FFE137",
    stroke: "#0E2032",
    strokeWidth: 0.798592,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0902 34.3145L36.7266 35.9543",
    stroke: "#0E2032",
    strokeWidth: 0.798592,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3905 35.9539L32.5597 40.9654V35.9769C32.5597 35.9769 29.7938 31.543 27.5804 31.543C25.4452 31.543 24.3565 35.7365 23.9298 37.9576C23.913 38.0382 23.9231 38.1221 23.9587 38.1963C23.9943 38.2706 24.0534 38.331 24.1267 38.3681C24.2001 38.4053 24.2836 38.4172 24.3644 38.4019C24.4452 38.3866 24.5187 38.3451 24.5735 38.2837C25.4737 37.321 26.945 36.0147 28.3905 35.9539Z",
    fill: "#FFE137",
    stroke: "#0E2032",
    strokeWidth: 0.798592,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0312 34.3145L28.3949 35.9543",
    stroke: "#0E2032",
    strokeWidth: 0.798592,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2765 27.0711C37.2351 27.3696 38.1517 27.7897 39.0039 28.3212C39.0714 28.3613 39.149 28.3809 39.2274 28.3776C39.3058 28.3744 39.3816 28.3484 39.4455 28.3028C39.5095 28.2573 39.5589 28.1942 39.5877 28.1211C39.6166 28.048 39.6236 27.968 39.608 27.891C39.322 26.4585 38.5754 23.7832 36.9892 23.7832C34.7758 23.7832 32.5625 28.2181 32.5625 28.2181V32.652L36.2765 27.0711Z",
    fill: "#FFE137",
    stroke: "#0E2032",
    strokeWidth: 0.798592,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9861 26.002L36.2734 27.0724",
    stroke: "#0E2032",
    strokeWidth: 0.798592,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8492 27.0711C27.8899 27.3692 26.9727 27.7894 26.12 28.3212C26.0525 28.3613 25.9749 28.3809 25.8965 28.3776C25.8181 28.3744 25.7423 28.3484 25.6784 28.3028C25.6144 28.2573 25.5651 28.1942 25.5362 28.1211C25.5074 28.048 25.5003 27.968 25.5159 27.891C25.8019 26.4585 26.5476 23.7832 28.1347 23.7832C30.3481 23.7832 32.5605 28.2181 32.5605 28.2181V32.652L28.8492 27.0711Z",
    fill: "#FFE137",
    stroke: "#0E2032",
    strokeWidth: 0.798592,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1328 26.002L28.8455 27.0724",
    stroke: "#0E2032",
    strokeWidth: 0.798592,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2765 18.7567C37.3487 19.1036 38.3722 19.5866 39.3221 20.1938C39.361 20.2174 39.4059 20.2293 39.4514 20.228C39.497 20.2266 39.5411 20.2121 39.5786 20.1863C39.6161 20.1604 39.6453 20.1242 39.6628 20.082C39.6802 20.0399 39.6852 19.9936 39.677 19.9487C39.4563 18.6783 38.7271 15.4688 36.9892 15.4688C34.7758 15.4688 32.5625 19.9036 32.5625 19.9036V24.3375L36.2765 18.7567Z",
    fill: "#FFE137",
    stroke: "#0E2032",
    strokeWidth: 0.798592,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9861 17.6855L36.2734 18.756",
    stroke: "#0E2032",
    strokeWidth: 0.798592,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8502 18.7567C27.7777 19.1036 26.7539 19.5866 25.8038 20.1938C25.7648 20.217 25.7199 20.2285 25.6746 20.227C25.6292 20.2255 25.5853 20.211 25.5479 20.1852C25.5106 20.1594 25.4814 20.1234 25.4638 20.0815C25.4462 20.0396 25.441 19.9935 25.4488 19.9487C25.6695 18.6783 26.3996 15.4688 28.1376 15.4688C30.3509 15.4688 32.5633 19.9036 32.5633 19.9036V24.3375L28.8502 18.7567Z",
    fill: "#FFE137",
    stroke: "#0E2032",
    strokeWidth: 0.798592,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1328 17.6855L28.8455 18.756",
    stroke: "#0E2032",
    strokeWidth: 0.798592,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5156 52.0528V19.9043",
    stroke: "#0E2032",
    strokeWidth: 0.798592,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6848 44.2703L13.5156 49.2827V44.2942C13.5156 44.2942 16.2825 39.8594 18.4949 39.8594C20.6301 39.8594 21.7189 44.0529 22.1464 46.274C22.1633 46.3546 22.1532 46.4385 22.1176 46.5128C22.082 46.587 22.0229 46.6474 21.9495 46.6845C21.8762 46.7217 21.7926 46.7336 21.7118 46.7183C21.6311 46.703 21.5576 46.6615 21.5028 46.6001C20.6053 45.6374 19.1267 44.3311 17.6848 44.2703Z",
    fill: "#FFE137",
    stroke: "#0E2032",
    strokeWidth: 0.798592,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0434 42.6309L17.6797 44.2697",
    stroke: "#0E2032",
    strokeWidth: 0.798592,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M9.34365 44.2703L13.5129 49.2827V44.2942C13.5129 44.2942 10.7469 39.8594 8.53354 39.8594C6.39836 39.8594 5.30963 44.0529 4.88296 46.274C4.86608 46.3546 4.87622 46.4385 4.91182 46.5128C4.94742 46.587 5.00649 46.6474 5.07986 46.6845C5.15322 46.7217 5.23677 46.7336 5.31756 46.7183C5.39834 46.703 5.47184 46.6615 5.52663 46.6001C6.42687 45.6374 7.89813 44.3311 9.34365 44.2703Z",
    fill: "#FFE137",
    stroke: "#0E2032",
    strokeWidth: 0.798592,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M7.98438 42.6309L9.34806 44.2697",
    stroke: "#0E2032",
    strokeWidth: 0.798592,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6848 35.9558L13.5156 40.9674V35.9788C13.5156 35.9788 16.2825 31.5449 18.4949 31.5449C20.6301 31.5449 21.7189 35.7384 22.1464 37.9595C22.1633 38.0401 22.1532 38.1241 22.1176 38.1983C22.082 38.2725 22.0229 38.3329 21.9495 38.3701C21.8762 38.4073 21.7926 38.4191 21.7118 38.4039C21.6311 38.3886 21.5576 38.347 21.5028 38.2856C20.6053 37.3229 19.1267 36.0166 17.6848 35.9558Z",
    fill: "#FFE137",
    stroke: "#0E2032",
    strokeWidth: 0.798592,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0434 34.3164L17.6797 35.9562",
    stroke: "#0E2032",
    strokeWidth: 0.798592,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M9.34365 35.9558L13.5129 40.9674V35.9788C13.5129 35.9788 10.7469 31.5449 8.53354 31.5449C6.39836 31.5449 5.30963 35.7384 4.88296 37.9595C4.86608 38.0401 4.87622 38.1241 4.91182 38.1983C4.94742 38.2725 5.00649 38.3329 5.07986 38.3701C5.15322 38.4073 5.23677 38.4191 5.31756 38.4039C5.39834 38.3886 5.47184 38.347 5.52663 38.2856C6.42687 37.3229 7.89813 36.0166 9.34365 35.9558Z",
    fill: "#FFE137",
    stroke: "#0E2032",
    strokeWidth: 0.798592,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M7.98438 34.3164L9.34806 35.9562",
    stroke: "#0E2032",
    strokeWidth: 0.798592,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2296 27.0731C18.1883 27.3715 19.1048 27.7917 19.957 28.3232C20.0245 28.3633 20.1022 28.3828 20.1806 28.3796C20.2589 28.3763 20.3347 28.3503 20.3987 28.3048C20.4626 28.2593 20.512 28.1961 20.5408 28.123C20.5697 28.0499 20.5767 27.97 20.5611 27.893C20.2752 26.4604 19.5285 23.7852 17.9423 23.7852C15.729 23.7852 13.5156 28.22 13.5156 28.22V32.6539L17.2296 27.0731Z",
    fill: "#FFE137",
    stroke: "#0E2032",
    strokeWidth: 0.798592,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9392 26.0039L17.2266 27.0744",
    stroke: "#0E2032",
    strokeWidth: 0.798592,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M9.80236 27.0731C8.84302 27.3712 7.92581 27.7913 7.07315 28.3232C7.00565 28.3633 6.92801 28.3828 6.84962 28.3796C6.77123 28.3763 6.69547 28.3503 6.63152 28.3048C6.56757 28.2593 6.51818 28.1961 6.48933 28.123C6.46049 28.0499 6.45343 27.97 6.46902 27.893C6.75499 26.4604 7.50074 23.7852 9.08787 23.7852C11.3012 23.7852 13.5136 28.22 13.5136 28.22V32.6539L9.80236 27.0731Z",
    fill: "#FFE137",
    stroke: "#0E2032",
    strokeWidth: 0.798592,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M9.08594 26.0039L9.79858 27.0744",
    stroke: "#0E2032",
    strokeWidth: 0.798592,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2296 18.7586C18.3018 19.1056 19.3253 19.5885 20.2752 20.1957C20.3141 20.2194 20.3591 20.2312 20.4046 20.2299C20.4501 20.2286 20.4942 20.2141 20.5317 20.1882C20.5692 20.1623 20.5985 20.1261 20.6159 20.084C20.6334 20.0419 20.6383 19.9956 20.6301 19.9507C20.4094 18.6803 19.6802 15.4707 17.9423 15.4707C15.729 15.4707 13.5156 19.9056 13.5156 19.9056V24.3395L17.2296 18.7586Z",
    fill: "#FFE137",
    stroke: "#0E2032",
    strokeWidth: 0.798592,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9392 17.6875L17.2266 18.758",
    stroke: "#0E2032",
    strokeWidth: 0.798592,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M9.80333 18.7586C8.73084 19.1056 7.70705 19.5885 6.75689 20.1957C6.71789 20.219 6.67306 20.2305 6.62772 20.229C6.58237 20.2274 6.53841 20.2129 6.50106 20.1871C6.4637 20.1613 6.43451 20.1254 6.41694 20.0835C6.39937 20.0415 6.39417 19.9955 6.40195 19.9507C6.62264 18.6803 7.35275 15.4707 9.09069 15.4707C11.304 15.4707 13.5164 19.9056 13.5164 19.9056V24.3395L9.80333 18.7586Z",
    fill: "#FFE137",
    stroke: "#0E2032",
    strokeWidth: 0.798592,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M9.08594 17.6875L9.79858 18.758",
    stroke: "#0E2032",
    strokeWidth: 0.798592,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoverCropIcon);
export default __webpack_public_path__ + "static/media/coverCropIcon.975d808792cbf2e25adf09007d526051.svg";
export { ForwardRef as ReactComponent };